import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "airport"
const AirportIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M5.25 15C6.492 15 7.5 16.007 7.5 17.25S6.492 19.5 5.25 19.5C4.007 19.5 3 18.493 3 17.25S4.007 15 5.25 15M5.25 16.5C4.836 16.5 4.5 16.836 4.5 17.25S4.836 18 5.25 18 6 17.664 6 17.25 5.664 16.5 5.25 16.5M18.75 15C19.992 15 21 16.007 21 17.25S19.992 19.5 18.75 19.5C17.507 19.5 16.5 18.493 16.5 17.25S17.507 15 18.75 15M18.75 16.5C18.336 16.5 18 16.836 18 17.25S18.336 18 18.75 18 19.5 17.664 19.5 17.25 19.164 16.5 18.75 16.5"
            clipRule="evenodd"
          />
          <path d="M10.205 11.358C11.407 11.213 12.622 11.214 13.824 11.36L13.64 12.851C12.56 12.717 11.466 12.715 10.384 12.846L10.294 12.102z" />
          <path
            fillRule="evenodd"
            d="M12 3C12.414 3 12.75 3.336 12.75 3.75V7.554C15.1 7.891 16.948 9.784 17.215 12.156L22.682 13.523C23.083 13.623 23.328 14.03 23.227 14.432 23.127 14.833 22.72 15.078 22.318 14.977L17.164 13.688C16.722 16.14 14.58 18 12 18 9.42 18 7.277 16.14 6.834 13.689L1.681 14.977C1.28 15.077.873 14.833.773 14.432.673 14.03.916 13.623 1.318 13.522L6.784 12.157C7.05 9.783 8.899 7.89 11.25 7.554V3.75C11.25 3.336 11.586 3 12 3M12 9C9.929 9 8.25 10.679 8.25 12.75S9.929 16.5 12 16.5 15.75 14.821 15.75 12.75 14.07 9 12 9"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default AirportIcon
